import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';
import ImageFluid from '../../legacy/components/base/ImageFluid';

interface Props {
  backgroundImage: { src: string };
  description: string;
  disclaimer?: string;
  alt: string;
}

export const VerticalCard = (props: Props) => {
  return (
    <Box flex={1} maxWidth={{ xs: 'fit-content', sm: 'min-content' }}>
      <Card sx={{ boxShadow: 'none', border: 'none', width: { xs: '100%', sm: 200 }, height: { xs: '100%', md: 'fit-content' }, p: 0 }}>
        <CardContent sx={{ p: 0, alignItems: 'center', textAlign: 'center', '&.MuiCardContent-root:last-child': { pb: 0 } }}>
          <Stack alignItems="center">
            <Box width="100%" height={{ xs: 104, sm: 138 }} borderRadius="12px 12px 12px 12px" flexShrink={0}>
              <ImageFluid
                fluid={props.backgroundImage}
                imgStyle={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  overflow: 'hidden',
                }}
                alt={props.alt}
              />
            </Box>

            <Typography variant="body2" fontSize={14} textAlign="left" mb={0} px={2} py={{ xs: 2, md: 4 }}>
              <RawHtml content={props.description} />
            </Typography>
          </Stack>
        </CardContent>
      </Card>
      {props.disclaimer ? (
        <Typography color="#272031" fontSize={12} fontFamily="Gotham-Light" mt={1.25} textAlign="center" px={2}>
          {props.disclaimer}
        </Typography>
      ) : null}
    </Box>
  );
};
